import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import Modal from 'core/components/Modal'
import Typography from 'core/components/Typography'

function RemoveFileDialog({ onClose, open, onConfirm }) {
  return (
    <Modal
      open={open}
      aria-labelledby="customized-dialog-title"
      textCancel={i18n.t('product.productUpload.close')}
      textConfirm={i18n.t('product.productUpload.remove')}
      onCancel={() => onClose(null)}
      onConfirm={() => onConfirm()}
    >
      <Typography variant="h5"> {i18n.t('product.productUpload.removeFile')}</Typography>
    </Modal>
  )
}

RemoveFileDialog.defaultProps = {
  onClose: null,
  open: false,
}

RemoveFileDialog.propTypes = {
  onClose: PropTypes.any,
  open: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
}

export default RemoveFileDialog
